'use strict';

var settingsModule = angular.module('t2g.common.settings', []);

module.exports = settingsModule;

var settings = {
  titlePrefix: 'Sanasearch',
  titleSeperator: '»',
  apiBase: '',
  mandant: 'coachfrog',
  modules: {
    invoice: true,
    tarif590: true,
  },
  billwerk: {
    key: '576a51a314a9ff0728fe006c',
    products: {
      chf: {
        basic: '58eb818e796508112c52bc9c',
        premium_monthly: '58eb7ec9675ecb0e607526bd',
        premium_yearly: '58eb7eff796508112c52b85c',
        employee: '58eb81c9675ecb0e60752ba3',
        sms: '58f6841614a9ff1434b12755',
      },
      eur: {
        basic: '58eb829c796508112c52be28',
        premium_monthly: '58eb824b675ecb0e60752c37',
        premium_yearly: '58eb8282796508112c52be05',
        employee: '58eb82d5675ecb0e60752d04',
        sms: '58f6842714a9ff138069f6d3',
      },
    },
    bearer: {
      creditCard: 'Stripe',
      payPal: 'PayPal',
      directDebit: 'Debit:FakePSP',
      invoice: 'InvoicePayment',
      none: 'None:None',
    },
  },
  paymentMethods: {
    at: ['payPal', 'creditCard', 'invoice'],
    de: ['payPal', 'creditCard', 'invoice'],
    ch: ['payPal', 'creditCard', 'invoice'],
  },
  invoiceFolder: '/api/v2/payment/',
  defaultLanguage: 'de',
  login: 'https://admin.sanasearch.ch/',
  login_url: 'https://www.sanasearch.ch/en/konto/login/',
  settingsForm: require('./settingsFields'),
  cancellation: {
    redirect: 'https://www.sanasearch.ch',
  },
  calendar: {
    contextMenu: {
      appointment: true,
      course: false,
      private: true,
      abort: true,
    },
  },
  i18nOverwrite: {
    de: {},
  },
  availableLanguages: ['de'],
  INTERCOM_APP_ID: 'hsklpp46',
  showUserlane: true,
  USERLANE_APP_ID: 32752,
};

// overwrite i18n
settings.i18nOverwrite.de['services'] = 'Angebote';
settings.i18nOverwrite.de['Services'] = 'Angebote';
settings.i18nOverwrite.de['Service'] = 'Angebot';
settings.i18nOverwrite.de['Add service'] = 'Angebot hinzufügen';
settings.i18nOverwrite.de['Do you realy want to delete that service?'] =
  'Wollen Sie dieses Angebot wirklich löschen?';
settings.i18nOverwrite.de['Enter services'] = 'Angebot hinzufügen';
settings.i18nOverwrite.de['Service "{{name}}" deleted'] = 'Angebot "{{name}}" wurde gelöscht';
settings.i18nOverwrite.de['Service "{{name}}" saved'] = 'Angebot "{{name}}" wurde gespeichert';
settings.i18nOverwrite.de['Service groups'] = 'Angebotsgruppen';
settings.i18nOverwrite.de['There should be at least one service group'] =
  'Es muss mindestens eine Gruppe bestehen bleiben.';
settings.i18nOverwrite.de['service edited'] = 'Angebot geändert';
settings.i18nOverwrite.de['service group "{{name}}" deleted'] =
  'Angebotsgruppe "{{name}}" wurde gelöscht';
settings.i18nOverwrite.de['service groups saved'] = 'Angebotsgruppe wurde gespeichert';
settings.i18nOverwrite.de['Service resource match'] = 'Angebote Mitarbeitern zuordnen';
settings.i18nOverwrite.de['Add appointment or customer'] = 'Termin oder Klient hinzufügen';
settings.i18nOverwrite.de['- Choose a Service -'] = '- Wählen Sie ein Angebot - ';
settings.i18nOverwrite.de[
  'The bookable appointments interval will adopt to booked service length.'
] = 'Der Abstand zwischen buchbaren Terminen passt sich der Dauer des gebuchten Angebotes an.';

settings.i18nOverwrite.de['Add customers'] = 'Klienten hinzufügen';
settings.i18nOverwrite.de['Cant add customer (Error: {{error}})'] =
  'Klient konnte nicht angelegt werden (Error: {{error}})';
settings.i18nOverwrite.de['Cant delete customer (Error: {{error}})'] =
  'Klient konnte nicht gelöscht werden (Error: {{error}})';
settings.i18nOverwrite.de['Cant update customer (Error: {{error}})'] =
  'Klient konnte nicht aktualisiert werden (Error: {{error}})';
settings.i18nOverwrite.de['Customer'] = 'Klient';
settings.i18nOverwrite.de['Customers'] = 'Klienten';
settings.i18nOverwrite.de['customer'] = 'Klient';
settings.i18nOverwrite.de['customers'] = 'Klienten';
settings.i18nOverwrite.de['Customer profile'] = 'Klientenprofil';
settings.i18nOverwrite.de['Do you really want to delete that customer?'] =
  'Wollen Sie wirklich diesen Klienten löschen?';
settings.i18nOverwrite.de['Download customer list (*.csv file)'] =
  'Klientenliste herunterladen (*.csv file)';
settings.i18nOverwrite.de['Export customer data'] = 'Klientenprofile exportieren';
settings.i18nOverwrite.de['Export billing data'] = 'Rechnungen exportieren';
settings.i18nOverwrite.de['Month'] = 'Monat';
settings.i18nOverwrite.de['Year'] = 'Jahr';
settings.i18nOverwrite.de['Whole year'] = 'Ganzes Jahr';
settings.i18nOverwrite.de['Invoice type'] = 'Rechnungstyp';
settings.i18nOverwrite.de['Download invoice list (*.csv file)'] =
  'Rechnungsliste herunterladen (*.csv file)';
settings.i18nOverwrite.de['Download invoices as PDF (*.zip file)'] =
  'Rechnungen als PDF herunterladen (*.zip file)';
settings.i18nOverwrite.de['Download customer invoices (*.csv file)'] =
  'Rechnungen dieses Klienten herunterladen (*.csv file)';
settings.i18nOverwrite.de['Download customer invoices as PDF (*.zip file)'] =
  'Rechnungen dieses Klienten als PDF herunterladen (*.zip file)';
settings.i18nOverwrite.de['New Customer'] = 'Neuer Klient';
settings.i18nOverwrite.de['Reach more customers'] = 'Mehr Klienten erreichen';
settings.i18nOverwrite.de[
  'Send notifications mails to customer about appointment changes (change start date, remove)'
] = 'den Klienten über die Terminänderung (Änderung Startzeit, Löschen) informieren';
settings.i18nOverwrite.de['notify customer via email'] = 'Klienten über Änderung benachrichtigen';
settings.i18nOverwrite.de['How can customers book an appointment in short notice.'] =
  'Wie kurzfristig können Klienten einen Termin bei Ihnen buchen?';
settings.i18nOverwrite.de['Add Customer'] = 'Klient hinzufügen';
settings.i18nOverwrite.de['Customers ({{CustomerListCtrl.customers.length}})'] =
  'Klienten ({{CustomerListCtrl.customers.length}})';

settings.i18nOverwrite.de['Close'] = 'Schliessen';
settings.i18nOverwrite.de['Sanasearch Profile'] = 'Sanasearch Profil';

settings.i18nOverwrite.de['Termin2go calendar'] = 'Sanasearch Calendar';
settings.i18nOverwrite.de['Termin2go field'] = 'Sanasearch Feld';

settings.i18nOverwrite.de['Global Email address'] = 'E-Mail Adresse';

settingsModule.constant('settings', settings);



// WEBPACK FOOTER //
// ./src/config/coachfrog/settings.production.js